
document.addEventListener('DOMContentLoaded', function(e) {
  if (typeof MagicGrid != 'undefined') {
    var magicGrid = new MagicGrid({
      container: '.masonry',
      animate: true,
      gutter: 45,
      static: true,
      maxColumns: 3,
      useMin: true
    });

    magicGrid.listen();
  }
});
